import { Whitelabel } from "src/types/whitelabel";
import { axiosInstance, endpoints } from "src/utils/axios";

class WhitelabelRepository {
  /**
   * Busca as configurações de whitelabel por hostname
   * @param host - Hostname do site (ex: 'localhost:5173' ou 'shopping-abc.com')
   * @returns Promise<Whitelabel>
   */
  static async getByShoppingId(host: string): Promise<Whitelabel> {
    try {
      const response = await axiosInstance.get(
        `${endpoints.admin.whitelabel}/${host}`,
      );
      return response.data.whitelabel;
    } catch (error: any) {
      throw new Error(`Failed to fetch whitelabel: ${error.message}`);
    }
  }
}

export const whitelabelRepository = WhitelabelRepository;
